module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Media/Rec-80743fcfe4908ea7987c30ab2a6346ba.svg";